import { DateRangeString, DateRange } from "types/global";
import { dateDiv } from "./dateRange_url";
import { dateWithoutTime } from "./time";


//#endregion
//#region DATE RANGE STRING
/**
 * Trasforma un DateRangeString in DateRange numerico (senza time)
 */

export function dateRangeStringToDateRange(range: DateRangeString): DateRange {
	return {
		start: dateWithoutTime(range.start),
		end: dateWithoutTime(range.end)
	}
}
/**
 * trasforma una stringa in un oggetto DateRangeString
 */

export function urlToDateRangeString(range: string): DateRangeString {
	const [start, end] = range?.split(dateDiv) ?? []
	return { start, end }
}
/**
 * Trasforma un oggetto DateRangeString in una stringa
 */

export function dateRangeStringToUrl(range: DateRangeString): string {
	const value = `${range?.start ?? ""}${dateDiv}${range?.end ?? ""}`
	return value
}
